
export enum crownType {
    none = 'none',
    C = 'C',
}